import { render, staticRenderFns } from "./ComparsionBar.vue?vue&type=template&id=bc662120&scoped=true&"
import script from "./ComparsionBar.vue?vue&type=script&lang=js&"
export * from "./ComparsionBar.vue?vue&type=script&lang=js&"
import style0 from "./ComparsionBar.vue?vue&type=style&index=0&id=bc662120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc662120",
  null
  
)

export default component.exports